  var $scrolTickerWrapperDiv = $(".scrolTickerwrapperDiv");
        var $list = $scrolTickerWrapperDiv.find("ul.scrollItemListUL");

        var $liItems = $list.find("li");

        // Define the number of times you want to clone the <li> items
        var numberOfClones = 5; // You can change this to 6 or any other number

        for (var i = 0; i < numberOfClones; i++) {
            var $clonedLiItems = $liItems.clone();
            $list.append($clonedLiItems);
        }

        var $list = $scrolTickerWrapperDiv.find("ul.scrollItemListUL");
        var $clonedList = $list.clone();
        var listWidth = 10;

        $list.find("li").each(function (i) {
            listWidth += $(this, i).outerWidth(true);
        });

        var endPos = $scrolTickerWrapperDiv.width() - listWidth;

        $list.add($clonedList).css({
            "width": listWidth + "px"
        });

        $clonedList.addClass("cloned").appendTo($scrolTickerWrapperDiv);

        //TimelineMax
        var infinite = new TimelineMax({ repeat: -1, paused: true });
        var time = 250;

        infinite
            .fromTo($list, time, { rotation: 0.01, x: 0 }, { force3D: true, x: -listWidth, ease: Linear.easeNone }, 0)
            .fromTo($clonedList, time, { rotation: 0.01, x: listWidth }, { force3D: true, x: 0, ease: Linear.easeNone }, 0)
            .set($list, { force3D: true, rotation: 0.01, x: listWidth })
            .to($clonedList, time, { force3D: true, rotation: 0.01, x: -listWidth, ease: Linear.easeNone }, time)
            .to($list, time, { force3D: true, rotation: 0.01, x: 0, ease: Linear.easeNone }, time)
            .progress(1).progress(0)
            .play();

        //Pause/Play		
        $scrolTickerWrapperDiv.on("mouseenter", function () {
            infinite.pause();
        }).on("mouseleave", function () {
            infinite.play();
        });



  var $scrolTickerWrapperDivImg = $(".scrolTickerwrapperDivImg");
        var $listImg = $scrolTickerWrapperDivImg.find("ul.scrollItemListULImg");

        var $liItemsImg = $listImg.find("li");

        // Define the number of times you want to clone the <li> items
        var numberOfClones = 5; // You can change this to 6 or any other number

        for (var i = 0; i < numberOfClones; i++) {
            var $clonedLiItems = $liItemsImg.clone();
            $listImg.append($clonedLiItems);
        }

        var $listImg = $scrolTickerWrapperDivImg.find("ul.scrollItemListULImg");
        var $clonedListImg = $listImg.clone();
        var listWidthImg = 10;

        $listImg.find("li").each(function (i) {
            listWidthImg += $(this, i).outerWidth(true);
        });

        var endPosImg = $scrolTickerWrapperDiv.width() - listWidthImg;

        $listImg.add($clonedListImg).css({
            "width": listWidthImg + "px"
        });

        $clonedListImg.addClass("cloned").appendTo($scrolTickerWrapperDiv);

        //TimelineMax
        var infiniteImg = new TimelineMax({ repeat: -1, paused: true });
        var timeImg = 250;

        infiniteImg
            .fromTo($listImg, timeImg, { rotation: 0.01, x: 0 }, { force3D: true, x: -listWidthImg, ease: Linear.easeNone }, 0)
            .fromTo($clonedListImg, timeImg, { rotation: 0.01, x: listWidthImg }, { force3D: true, x: 0, ease: Linear.easeNone }, 0)
            .set($listImg, { force3D: true, rotation: 0.01, x: listWidthImg })
            .to($clonedListImg, timeImg, { force3D: true, rotation: 0.01, x: -listWidthImg, ease: Linear.easeNone }, timeImg)
            .to($listImg, timeImg, { force3D: true, rotation: 0.01, x: 0, ease: Linear.easeNone }, timeImg)
            .progress(1).progress(0)
            .play();

        //Pause/Play		
        $scrolTickerWrapperDiv.on("mouseenter", function () {
            infiniteImg.pause();
        }).on("mouseleave", function () {
            infiniteImg.play();
        });